export default __webpack_public_path__ + "static/media/tarra-logotype-d.5ce9ee12.svg";